import React from 'react';
import './student-widget-wrapper.scss';
import {useInView} from 'react-intersection-observer';
import classNames from 'classnames';

require('intersection-observer');

export const StudentWidgetWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0.05,
    triggerOnce: true,
  });
  return (
    <div
      ref={ref}
      className={classNames('student-widget-wrapper', {
        'student-widget-wrapper--fade-in': inView,
      })}
    >
      {children}
    </div>
  );
};
